import { User } from "firebase/auth";
import { apiFetch } from "./client";

export interface SPClub {
  id: string;
  name: string;
  shortName: string | null;
  crest: string | null;
}

export interface SPMemberPrediction {
  memberId: string;
  displayName: string;
  homeScore: number;
  awayScore: number;
  points: number | null;
}

export interface SPFixture {
  id: string;
  homeClub: SPClub;
  awayClub: SPClub;
  kickoffTime: string | null;
  status: string;
  homeScore: number | null;
  awayScore: number | null;
  locked: boolean;
  myPrediction: { homeScore: number; awayScore: number; points: number | null } | null;
  memberPredictions: SPMemberPrediction[] | null;
}

export interface SPGameweek {
  id: string;
  number: number;
  name: string;
  shortName: string | null;
  completedAt: string | null;
  myScore: number;
  fixtureCount: number;
  finishedCount: number;
  predictedCount: number;
}

export interface SPLeaderboardEntry {
  memberId: string;
  displayName: string;
  totalScore: number;
  rank: number;
}

export interface ScorePredictorResponse {
  leagueStatus?: "PREPARING" | "RUNNING" | "COMPLETED";
  gameweeks: SPGameweek[];
  selectedGameweekId: string | null;
  fixtures: SPFixture[];
  leaderboard: SPLeaderboardEntry[];
  myRank?: number | null;
  memberCount?: number;
  leagueGwAverage?: number | null;
  viewMemberDisplayName?: string | null;
}

export function getScorePredictor(
  user: User,
  leagueId: string,
  gameweekId?: string,
  viewMemberId?: string,
): Promise<ScorePredictorResponse> {
  const params = new URLSearchParams();
  if (gameweekId) params.set("gameweekId", gameweekId);
  if (viewMemberId) params.set("viewMemberId", viewMemberId);
  const qs = params.size > 0 ? `?${params}` : "";
  return apiFetch(user, `/leagues/${leagueId}/score-predictor${qs}`);
}

export function savePrediction(
  user: User,
  leagueId: string,
  fixtureId: string,
  homeScore: number,
  awayScore: number,
): Promise<{ saved: boolean }> {
  return apiFetch(user, `/leagues/${leagueId}/score-predictor/${fixtureId}`, {
    method: "PUT",
    body: JSON.stringify({ homeScore, awayScore }),
  });
}

